import { LitElement } from "lit";

class AuthFormContent extends LitElement {
    static properties = { content: { attribute: false } };

    render() {
        return this.content;
    }
}

customElements.define("dat-auth-form-content", AuthFormContent);
